import { Box } from "@mui/material";
import { Logo } from "./logo";
import { Loader } from "./loader";

export const SplashScreen = () => (
  <Box
    sx={{
      alignItems: "center",
      backgroundColor: "background.paper",
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      justifyContent: "center",
      left: 0,
      p: 3,
      position: "fixed",
      top: 0,
      width: "100vw",
      zIndex: 1400,
    }}
  >
    <Box
      sx={{
        height: 75,
        width: 75,
      }}
    >
      <Logo />
    </Box>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 100,
        paddingLeft: "2rem",
      }}
    >
      <Loader />
    </Box>
  </Box>
);
